import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Prompt } from "react-router-dom";
import {
  Box,
  Card,
  TextField,
  Typography,
  Link as MuiLink,
  CardContent,
  Grid,
  makeStyles,
  Theme,
  Switch,
  Divider,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Fade,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import IconButton from "@material-ui/core/IconButton";
import Close from "@material-ui/icons/Close";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";

import TabHeader from "src/components/TabHeader/TabHeader";
import { VehicleManagementRoute } from "../../vehicle-management.routes";
import { columns } from "./components/columns";
import { searchData } from "src/app-redux/common-actions";
import * as Yup from "yup";
import {
  createVehicleInspectionScanner,
  deleteVehicleInspectionScanner,
  getLocationAtTerminal,
  getSecondaryInspectionDepartments,
  updateVehicleInspectionScanner,
} from "src/app-redux/vehicle/actions/vehicleActions";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { useAppSelector } from "src/app-redux/hooks";
import {
  selectLocationAtTerminal,
  setSelectedVehicleScanId,
  loader as vehicleLoader,
} from "src/app-redux/vehicle/vehicleSlice";
import { useDropzone } from "react-dropzone";
import { getAllFileCompressionConfigs } from "src/app-redux/configuration/actions/configurationActions";
import Drawer from "./components/Drawer";
import { filteryByArr, scannerComments } from "src/common/utils/app.dropdowns";
import MultiSelect2 from "src/components/molecules/MultiSelect2";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";
import { Tooltip } from "@mui/material";
import { filterBy } from "src/common/utils/helpers";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { Check } from "@material-ui/icons";
import CommonLoader from "src/components/Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  button: {
    margin: theme.spacing(1),
  },
  hideDatesGrid: {
    display: "none",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  legend: { fontWeight: "bold", color: "black", fontSize: "12px" },
  multiselectConfigFileCompression: {
    position: "relative",
    paddingLeft: "4px",
    "& .searchWrapper": {
      border: "none",
      maxHeight: "35px",
      overflow: "auto",
    },
    "& ::placeholder": {
      color: "#bcbcbc",
    },
  },
  readOnyTitle: {
    fontWeight: "bold",
  },
}));

interface Props {}

export function InspectionScanner({}: Props): React.ReactElement {
  const isExportString = localStorage.getItem("isAllowToExportData");
  const isExport = isExportString === "true";
  const classes = useStyles();
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [moduleName, setmoduleName] = useState<any>(VehicleManagementRoute.title);
  const [vehicleRecord, setvehicleRecord] = React.useState<GridRowModel[]>([]);
  const [pageHeading, setpageHeading] = useState<any>("Vehicle Inspection Scanner");
  const [loader, setLoader] = useState<any>(false);
  const loader2: any = useAppSelector(vehicleLoader);
  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);

  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [vehicleStatusArr, setvehicleStatusArr] = React.useState<any[]>([]);
  let allVehicleStatusesArr: any[] = [];
  const [vehicleRegNumberArr, setvehicleRegNumberArr] = React.useState<any[]>([]);
  const [vehicleNumber, setVehicleNumber] = useState<any>("");
  const [vehicleNumberLength, setVehicleNumberLength] = useState<number>(0);
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [isEditMode, setisEditMode] = React.useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = React.useState(false);

  const [fileToUpload, setFileToUpload] = React.useState<any[]>([]);
  const [validFileTypes, setValidFileTypes] = React.useState<any>([]);
  const [validFileSize, setValidFileSize] = React.useState(0);
  const [isValidFileType, setIsValidFileType] = React.useState<boolean[]>([]);
  const [isValidFileSize, setIsValidFileSize] = React.useState<boolean[]>([]);
  const [selectedComments, setSelectedComments] = useState<string[]>([]);
  const [enableSecondaryInspection, setEnableSecondaryInspection] = useState<boolean>(false);
  const [inspectionDepartmentsArr, setinspectionDepartmentsArr] = useState<any[]>([]);
  const multiselectRef: any = useRef();
  const [secondaryInspectionTerminalId, setSecondaryInspectionTerminalId] = useState<any>(-1);
  const [deleteRemarks, setDeleteRemarks] = useState("");
  const [isDeleteMode, setIsDeleteMode] = React.useState(false);
  const [cameraOpen, setCameraOpen] = useState<boolean>(false);
  const [imageDataURL, setImageDataURL] = useState<any>(null);
  const [cameraNumber, setCameraNumber] = useState(0);
  const playerRef = useRef<HTMLVideoElement | null>(null);

  let fileTypesArr: any[] = [];
  let maxFileSize = 0;
  const commentsArr = scannerComments;

  const onDrop = React.useCallback((acceptedFiles: File[]) => {
    const size: boolean[] = [];
    const type: boolean[] = [];

    acceptedFiles.forEach((file: any) => {
      const split = file?.name?.split(".");
      type.push(fileTypesArr.includes(`.${split[split.length - 1]}`.toLowerCase()));
      size.push(file.size / (1024 * 1024) <= maxFileSize);
    });

    setIsValidFileSize(size);
    setIsValidFileType(type);
    setFileToUpload(acceptedFiles);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  useEffect(() => {
    getFileConfig();
  }, []);

  const getFileConfig = async () => {
    const res: any = await dispatch(getAllFileCompressionConfigs());
    if (res.payload && res.payload[0]) {
      const fileTypes = res.payload[0]?.fileTypes?.split(",").map((type: string) => type.trim());
      setValidFileTypes(fileTypes);
      setValidFileSize(res.payload[0].fileSizeThreshold);
      fileTypesArr = fileTypes;
      maxFileSize = res.payload[0].fileSizeThreshold;
    }
  };

  // Redux
  const locationAtTerminalArr: any = useAppSelector(selectLocationAtTerminal);

  /* AXIOS Calls */
  const getVehicleStatusListing = async () => {
    let results: any = [];
    try {
      setLoader(true);
      results = await fetchWrapper.get("vehicle-status-get-all?ShowIsActive=true");
      if (results.isSuccess) {
        setvehicleStatusArr(results.value);
        allVehicleStatusesArr = results.value;
      }
      setLoader(false);
      return;
    } catch (error: any) {
      setLoader(false);
    }
  };
  const getVehicleStatusByVehicleId = async (id: number, title: string) => {
    let results: any = [];
    try {
      setLoader(true);
      results = await fetchWrapper.get(`get-vehicle-status-id-by-vehicle-Id/${id}`);
      if (results.isSuccess == true) {
        setValues({
          ...values,
          vehicleStatusId: results.value.vehicleStatusId,
          cargoType: results.value.cargoTypeName,
          consignmentType: results.value.consignmentTypeName,
          vehicleType: results.value.vehicleType,
          remarks: results.value.remarks || "",
          entryDateTime: results.value.dateTime,
          registrationNumber: title,
          startTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
        });
      }
      setLoader(false);
      return;
    } catch (error: any) {
      setLoader(false);
    }
  };
  const getVehicleByRegistrationNo = async (queryString: string) => {
    let results: any = [];
    results = await fetchWrapper.get(
      `search-vehicles-by-vehicle-registration-number/${queryString}`
    );
    if (results.isSuccess) {
      setvehicleRegNumberArr(results.value);
    }
    return;
  };
  /*./AXIOS Calls */

  const { height } = UseWindowDimensions();
  let dppr = 10;
  if (height > 700 && height < 900) {
    dppr = 15;
  } else if (height > 900) {
    dppr = 25;
  } else {
    dppr = 10;
  }
  const validationSchema = Yup.object().shape({
    remarks: Yup.string().max(3000, "Maximum 3000 characters allowed"),
    registrationNumber: Yup.string()
      .max(20, "Maximum 20 characters allowed")
      .required("This field is required"),
    refNum: Yup.string().max(50, "Maximum 50  characters allowed"),
    comment: Yup.string().max(3000, "Maximum 3000 characters allowed"),
    anomly: Yup.string().required("This field is required"),
    secondaryInspection: enableSecondaryInspection
      ? Yup.string().required("This field is required")
      : Yup.string(),
    terminalLocationId: Yup.string().required("This field is required"),
  });
  const [forceSave, setForceSave] = useState<any>(false);

  const formik = useFormik({
    initialValues: {
      InProgressVehiclesDataOnly: false,
      deepScan: false,
      filterBy: "today",
      startDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      vehicleScanId: 0,
      terminalLocationId: "",
      registrationNumber: "",
      vehicleStatusId: "",
      refNum: "",
      comment: "",
      anomly: "",
      cargoType: "",
      consignmentType: "",
      vehicleType: "",
      entryDateTime: "",
      secondaryInspection: "",
      remarks: "",
      startTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
      endTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      if (values.vehicleStatusId == "" || values.vehicleType == "") {
        dispatch(
          addNotificationAction({
            message: "Select vehicle number first!",
            options: { variant: "error" },
          })
        );
        return;
      }
      setLoader(true);
      const form = new FormData();
      form.append(
        "terminalLocationId",
        locationAtTerminalArr.find((st: any) => st.name === values.terminalLocationId)?.id
      );
      form.append("remarks", values.remarks || "");
      form.append("registrationNumber", values.registrationNumber);
      form.append("vehicleStatusId", values.vehicleStatusId);
      form.append("refNum", values.refNum);
      form.append("comment", values.comment);
      form.append("anomly", values.anomly);
      form.append("forceSave", forceSave);
      form.append("secondaryInspection", values.secondaryInspection || "");
      form.append("secondaryInspectionTerminalId", secondaryInspectionTerminalId || -1);
      form.append("isNodVehicle", "false");
      form.append("IsDeepScan", values.deepScan ? "true" : "false");

      fileToUpload.length
        ? fileToUpload.forEach((file) => {
            form.append("files", file);
          })
        : form.append("files", "");

      let res: any;
      if (isEditMode) {
        form.append("vehicleScanId", values.vehicleScanId);
        res = await dispatch(updateVehicleInspectionScanner(form));
      } else {
        form.append("startTime", values.startTime);
        form.append("endTime", moment().format("YYYY-MM-DDTHH:mm:ss"));
        res = await dispatch(createVehicleInspectionScanner(form));
        if (res.payload?.isScanAlreadyExist === true && forceSave === false) {
          setIsOpenSaveDailog(true);
        }
      }
      if ((isEditMode && res) || res.payload?.isScanAlreadyExist === false) {
        handleSearch();
        actions.setSubmitting(false);
        actions.resetForm();
        resetSearch();
        setSecondaryInspectionTerminalId(-1);
        setFileToUpload([]);
        setIsValidFileType([]);
        setIsValidFileSize([]);
        setIsDirty(false);
        getLocations();
        setForceSave(false);
      }
      setLoader(false);
    },
  });
  const { values, setValues } = formik;
  const handleSearch = async () => {
    const { filterBy, startDate, endDate, InProgressVehiclesDataOnly } = values;
    const body = {
      filterBy: filterBy || null,
      startDate: startDate || null,
      endDate: endDate || null,
      InProgressVehiclesDataOnly: InProgressVehiclesDataOnly || false,
      isNodVehicle: false,
    };
    setvehicleRecord([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchData("/get-all-vehicle-inspection-scans", JSON.stringify(body))
      );
      const record = results.vehicleInspectionScans;
      if (record) {
        const transformedData = record.map((data: any, index: any) => {
          return { ...data, vehicleScanId: data.id, id: index };
        });
        setvehicleRecord(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };
  const resetSearch = () => {
    const current = multiselectRef?.current;
    if (current) {
      current?.getUpdated();
    }

    setisEditMode(false);
    setValues({ ...formik.initialValues, terminalLocationId: "Scanner Station (Passthrough)" });
    setIsDirty(false);
    setFileToUpload([]);
    setSelectedComments([]);
    setEnableSecondaryInspection(false);
  };

  const [resetHandler, setResetHandler] = useState(false);

  const resetGrid = () => {
    setValues({
      ...formik.values,
      InProgressVehiclesDataOnly: formik.initialValues.InProgressVehiclesDataOnly,
      filterBy: formik.initialValues.filterBy,
      startDate: formik.initialValues.startDate,
      endDate: formik.initialValues.endDate,
    });
    setIsCustomDate(false);
    setResetHandler(true);
  };

  useEffect(() => {
    formik.setFieldValue("filterBy", "today");
    setLoader(true);
    handleSearch();
    setResetHandler(false);
  }, [resetHandler]);

  useEffect(() => {
    getVehicleStatusListing();
    getLocations();
    getDepartments();
    dispatch(getLocationAtTerminal());
  }, []);

  const getLocations = async () => {
    formik.setFieldValue("terminalLocationId", "Scanner Station (Passthrough)");
  };

  const getDepartments = async () => {
    const res: any = await dispatch(getSecondaryInspectionDepartments());
    if (res.payload.length) {
      setinspectionDepartmentsArr(res.payload);
    }
  };

  const filterByAction = (data: any) => {
    formik.setFieldValue("filterBy", data.value);
    if (data && data.value) {
      const res = filterBy(data);
      if (res?.isCustomDate) {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", res?.startDate);
        formik.setFieldValue("endDateCustom", res?.endDate);
      } else {
        setIsCustomDate(false);
      }
      formik.setFieldValue("startDate", res?.startDate);
      formik.setFieldValue("endDate", res?.endDate);
    }
  };
  const anomalyDetectionArr = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];
  const handleUpdateClick = async (params: any) => {
    setLoader(true);
    setSelectedRecord(params);
    const commentSplitArr = params?.comment?.split(",");
    const arr: any[] = [];
    commentSplitArr.forEach((item: any) => {
      const comment = commentsArr.find((indexVal) => indexVal.comment === item);
      if (comment) arr.push(comment);
    });
    setEnableSecondaryInspection(params.anomly === "yes");
    setSelectedComments(arr);
    await formik.setValues({
      ...formik.values,
      registrationNumber: params.registrationNumber,
      vehicleScanId: params.vehicleScanId,
      vehicleStatusId: params.vehicleStatusId,
      terminalLocationId:
        params.terminalLocation === "Scanner Station (Passthrough)" ||
        params.terminalLocation === "Scanner Station (Gantry)"
          ? params.terminalLocation
          : "Scanner Station (Passthrough)",
      refNum: params.refNum,
      comment: params?.comment?.split(",").toString(),
      anomly: params.anomly,
      secondaryInspection: params.secondaryInspection || "",
      cargoType: params.cargoTypeName,
      consignmentType: params.consignmentType,
      vehicleType: params.vehicleType,
      remarks: params.remarks || "",
      entryDateTime: params.gateEntryTime,
      deepScan: params.deepScan ?? false,
    });

    setSecondaryInspectionTerminalId(params.secondaryInspectionTerminalId);
    setisEditMode(true);
    setLoader(false);
  };

  const [isOpenDeleteDailog, setIsOpenDeleteDailog] = useState<boolean>(false);
  const [isOpenSaveDailog, setIsOpenSaveDailog] = useState<boolean>(false);
  const [deleteGridItem, setDeleteGridItem] = useState<any>("");
  const handleCloseDeleteDialog = () => {
    setIsDeleteMode(false);
    setDeleteRemarks("");
    setIsOpenDeleteDailog(false);
  };

  const handleDeleteDialog = async () => {
    setIsDeleteMode(true);
    if (deleteRemarks) {
      setIsOpenDeleteDailog(false);

      if (deleteGridItem) {
        const body = { ...deleteGridItem, deleteRemarks: deleteRemarks };
        const res: any = await dispatch(deleteVehicleInspectionScanner(body));
        if (res.payload) {
          handleSearch();
          formik.resetForm();
          setIsDeleteMode(false);
          setDeleteRemarks("");
          setFileToUpload([]);
          setIsValidFileType([]);
          setIsValidFileSize([]);
          setIsDirty(false);
          getLocations();
        }
      }
    }
  };

  const handleDelete = (id: any) => {
    setIsOpenDeleteDailog(true);
    setDeleteGridItem(id);
  };

  const handleCloseSaveDialog = () => {
    setIsOpenSaveDailog(false);
  };

  const handleSaveDialog = async () => {
    setIsOpenSaveDailog(false);
    setForceSave(true);
    formik.submitForm();
  };

  const scannerSavehandler = () => {
    formik.submitForm();
  };

  useEffect(() => {
    if (vehicleRecord.length) {
      const transformedColumns: any = columns.map((column: any) => {
        const isDeepScan = (row: any) => row.original?.deepScan === 1;
        const textColor = (row: any) => (isDeepScan(row) ? "#FF0000" : undefined);

        return column.accessorKey === "remarks"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <Tooltip title={renderedCellValue} followCursor>
                    <span style={{ color: textColor(row) }}>{renderedCellValue}</span>
                  </Tooltip>
                );
              },
            }
          : column.accessorKey === "serialNumber"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <div style={{ color: textColor(row) }}>
                    {renderedCellValue ? renderedCellValue : "--"}
                  </div>
                );
              },
            }
          : column.accessorKey === "files"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <MuiLink
                    className="customMuiLink"
                    onClick={() => {
                      dispatch(
                        setSelectedVehicleScanId({
                          scanId: row.original.vehicleScanId,
                          regNo: row.original.registrationNumber,
                          isNodWeightFile: false,
                        })
                      );
                      setisDrawerOpen(true);
                    }}
                    style={{ color: textColor(row) }}
                  >
                    View
                  </MuiLink>
                );
              },
            }
          : column.accessorKey === "actions"
          ? {
              ...column,
              size: 260,
              minSize: 240,
              Cell: function customCell({ row }: any) {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      whiteSpace: "nowrap",
                      alignItems: "center",
                    }}
                  >
                    <NewCommonButton
                      onClick={() => {
                        setIsDirty(true);
                        handleUpdateClick(row.original);
                      }}
                      icon={<EditIcon />}
                      isEdit={true}
                    >
                      Edit
                    </NewCommonButton>
                    {row.original.anomly === "yes" && row.original.deepScan === 0 && (
                      <NewCommonButton
                        onClick={() => {
                          handleDSClick(row.original);
                        }}
                        style={{ visibility: "visible" }} // Ensure always visible
                        isGreen
                      >
                        Deep Scan
                      </NewCommonButton>
                    )}
                    <NewCommonButton
                      onClick={() => {
                        handleDelete(row.original);
                      }}
                      icon={<DeleteIcon />}
                      disable={!row.original.vehicleInProgress || row.original.anomly == "yes"}
                      style={{ visibility: "visible" }}
                    >
                      Delete
                    </NewCommonButton>
                  </div>
                );
              },
            }
          : column.accessorKey === "vehicleInProgress"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.vehicleInProgress ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.vehicleInProgress ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : {
              ...column,
              Cell: function customCell({ renderedCellValue, row }: any) {
                return <div style={{ color: textColor(row) }}>{renderedCellValue || ""}</div>;
              },
            };
      });

      setDisplayColumns(transformedColumns);
    }
  }, [vehicleRecord]);
  const [isDirty, setIsDirty] = React.useState<boolean>(false);
  useEffect(() => {
    window.onbeforeunload = function (e: Event) {
      if (isDirty) {
        e.preventDefault();
        return "Changes you made may not be saved.";
      }
    };
  }, [isDirty]);
  function handleChange(e: any) {
    formik.handleChange(e);
    e.target.value || JSON.stringify(formik.values) !== JSON.stringify(formik.initialValues)
      ? setIsDirty(true)
      : setIsDirty(false);
  }
  const handleDSClick = async (rowData: any) => {
    try {
      const response = await fetchWrapper.post("check_in_smith_deep_scan", {
        id: rowData.id,
        // Add more payload fields if required by your API
      });

      if (response.isSuccess) {
      } else {
      }
    } catch (error) {}
  };

  const removeFileFromIndex = (index: number) => {
    const upload = fileToUpload;
    upload.splice(index, 1);
    setFileToUpload(upload);

    const size: boolean[] = [];
    const type: boolean[] = [];

    fileToUpload.forEach((file: any) => {
      const split = file?.name?.split(".");
      type.push(validFileTypes.includes(`.${split[split.length - 1]}`));
      size.push(file.size / (1024 * 1024) <= validFileSize);
    });

    setIsValidFileSize(size);
    setIsValidFileType(type);
  };

  // Camera capture functionality
  const dataURLtoFile = (dataurl: any, filename: any) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  const getListOfVideoInputs = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      return devices.filter((device) => device.kind === "videoinput");
    } catch (error) {
      console.error("Error enumerating devices:", error);
      return [];
    }
  };

  const openCamera = async () => {
    setImageDataURL(null);
    setCameraOpen(true);

    if (!("mediaDevices" in navigator)) {
      dispatch(
        addNotificationAction({
          message: "Camera not supported in this browser",
          options: { variant: "error" },
        })
      );
      return;
    }

    if (!("getUserMedia" in navigator.mediaDevices)) {
      dispatch(
        addNotificationAction({
          message: "Camera access not supported in this browser",
          options: { variant: "error" },
        })
      );
      return;
    }

    try {
      const videoInputs = await getListOfVideoInputs();

      if (videoInputs.length === 0) {
        dispatch(
          addNotificationAction({
            message: "The device does not have a camera",
            options: { variant: "error" },
          })
        );
        setCameraOpen(false);
        return;
      }
      if (cameraNumber >= videoInputs.length) {
        console.error("Invalid camera number");
        setCameraOpen(false);
        return;
      }
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          deviceId: videoInputs[cameraNumber].deviceId
            ? { ideal: videoInputs[cameraNumber].deviceId }
            : undefined,
        },
      });
      if (playerRef.current) {
        playerRef.current.srcObject = stream;
      } else {
        console.error("Video player element not found");
        setCameraOpen(false);
      }
    } catch (error) {
      if (error instanceof Error && error.name === "OverconstrainedError") {
        dispatch(
          addNotificationAction({
            message: "The selected camera is not available. Falling back to the default camera.",
            options: { variant: "warning" },
          })
        );
        try {
          const fallbackStream = await navigator.mediaDevices.getUserMedia({ video: true });
          if (playerRef.current) {
            playerRef.current.srcObject = fallbackStream;
          }
        } catch (fallbackError) {
          dispatch(
            addNotificationAction({
              message: "An error occurred while accessing the camera.",
              options: { variant: "error" },
            })
          );
          setCameraOpen(false);
        }
      } else {
        dispatch(
          addNotificationAction({
            message: "An error occurred while accessing the camera.",
            options: { variant: "error" },
          })
        );
        setCameraOpen(false);
      }
    }
  };

  const closeCamera = () => {
    setImageDataURL(null);
    if (playerRef.current?.srcObject) {
      const tracks = (playerRef.current.srcObject as MediaStream).getTracks();
      tracks.forEach((track) => track.stop());
      playerRef.current.srcObject = null;
    }
    setCameraOpen(false);
  };

  const captureImage = async () => {
    if (!playerRef.current) return;

    const canvas = document.createElement("canvas");
    canvas.width = playerRef.current.videoWidth;
    canvas.height = playerRef.current.videoHeight;
    const context = canvas.getContext("2d");
    if (context) {
      context.drawImage(playerRef.current, 0, 0, canvas.width, canvas.height);
      const imageSrc = canvas.toDataURL();

      // Stop the camera stream
      if (playerRef.current?.srcObject) {
        const tracks = (playerRef.current.srcObject as MediaStream).getTracks();
        tracks.forEach((track) => track.stop());
        playerRef.current.srcObject = null;
      }

      setImageDataURL(imageSrc);
    }
  };

  const confirmAndAddImage = async () => {
    if (!imageDataURL) return;

    // Use validFileTypes state and normalize comparison (trim and lowercase)
    const validTypes = validFileTypes.length > 0 ? validFileTypes : fileTypesArr;
    const normalizedValidTypes = validTypes.map((type: string) => type.trim().toLowerCase());

    // Determine which image extension to use (.jpg or .jpeg) based on what's in allowed types
    let imageExtension = ".jpg";
    if (normalizedValidTypes.includes(".jpeg") && !normalizedValidTypes.includes(".jpg")) {
      imageExtension = ".jpeg";
    } else if (normalizedValidTypes.includes(".jpg")) {
      imageExtension = ".jpg";
    } else if (normalizedValidTypes.includes(".jpeg")) {
      imageExtension = ".jpeg";
    }

    // Convert to file and add to fileToUpload
    const timestamp = moment().format("YYYYMMDD_HHmmss");
    const capturedFile = dataURLtoFile(imageDataURL, `CameraImage_${timestamp}${imageExtension}`);

    // Validate file type and size
    const split = capturedFile.name.split(".");
    const fileExtension = `.${split[split.length - 1]}`.toLowerCase();
    const isValidType = normalizedValidTypes.includes(fileExtension);
    const isValidSize = capturedFile.size / (1024 * 1024) <= validFileSize;

    if (!isValidType) {
      dispatch(
        addNotificationAction({
          message: `Only ${validTypes.join(", ")} files are allowed.`,
          options: { variant: "error" },
        })
      );
      setImageDataURL(null);
      openCamera();
      return;
    }

    if (!isValidSize) {
      dispatch(
        addNotificationAction({
          message: `File size cannot exceed ${validFileSize}MB.`,
          options: { variant: "error" },
        })
      );
      setImageDataURL(null);
      openCamera();
      return;
    }

    // Add to fileToUpload array
    const newFiles = [...fileToUpload, capturedFile];
    setFileToUpload(newFiles);

    // Update validation arrays
    const size: boolean[] = [];
    const type: boolean[] = [];
    newFiles.forEach((file: any) => {
      const fileSplit = file?.name?.split(".");
      const ext = `.${fileSplit[fileSplit.length - 1]}`.toLowerCase();
      const normalizedTypes = validTypes.map((t: string) => t.trim().toLowerCase());
      type.push(normalizedTypes.includes(ext));
      size.push(file.size / (1024 * 1024) <= validFileSize);
    });
    setIsValidFileSize(size);
    setIsValidFileType(type);

    // Close camera and show success message
    closeCamera();
    dispatch(
      addNotificationAction({
        message: "Image captured and added successfully",
        options: { variant: "success" },
      })
    );
  };

  useEffect(() => {
    return () => {
      if (playerRef.current?.srcObject) {
        const tracks = (playerRef.current.srcObject as MediaStream).getTracks();
        tracks.forEach((track) => track.stop());
        playerRef.current.srcObject = null;
      }
    };
  }, []);

  const onMultiSelectSelection = (selectedList: any) => {
    const comments: string = selectedList
      .map((item: any) => (item.comment ? item.comment : ""))
      .toString();
    formik.setFieldValue("comment", comments);
  };
  const onMultiSelectRemove = (selectedList: any) => {
    const comments: string = selectedList
      .map((item: any) => (item.comment ? item.comment : ""))
      .toString();
    formik.setFieldValue("comment", comments);
  };

  const listener: any = (e: any) => {
    if (
      (e.key === "s" || e.key === "S") &&
      (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
    ) {
      e.preventDefault();
      if (!loader && !loader2 && !isOpenSaveDailog) formik.submitForm();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [loader, loader2, isOpenSaveDailog]);

  const exportHandler = async (row: any) => {
    dispatch(
      addNotificationAction({
        message: "Your download will begin shortly",
        options: { variant: "success" },
      })
    );
    const exportedRecords = await row?.map((data: any) => {
      return {
        "Serial #": data?.serialNumber,
        Vehicle: data?.registrationNumber,
        Status: data?.vehicleStatus,
        Type: data?.vehicleType,
        Consignment: data?.consignmentType,
        Cargo: data?.cargoTypeName,
        Location: data?.terminalLocation,
        Anomly: data?.anomly,
        "Secondary Insp": data?.secondaryInspection,
        "Start Time": data.gateEntryDate
          ? moment(data.gateEntryDate).format("DD-MM-YYYY hh:mm:ss A")
          : "",
        "End Time": data.endTime ? moment(data.endTime).format("DD-MM-YYYY hh:mm:ss A") : "",
        "In Progress": data.vehicleInProgress ? "Yes" : "No",
        "Reference #": data?.refNum,
        "Possible Issues": data?.comment,
        Remarks: data?.remarks,
      };
    });
    return exportedRecords;
  };

  return (
    <div>
      <Prompt when={isDirty} message="Changes you made may not be saved." />
      <Prompt when={deleteConfirmation} message="Are you sure you want to delete?" />
      <TabHeader module={moduleName} heading={pageHeading} link={VehicleManagementRoute.path} />
      <Backdrop className={classes.backdrop} open={loader || loader2}>
        <CommonLoader />
      </Backdrop>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={9}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}> {pageHeading} </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={3}>
              <Box textAlign="right" mt={1} mb={1}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
                  Reset
                </CommonButton>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  onClick={() => {
                    scannerSavehandler();
                  }}
                >
                  {isEditMode ? "Update" : "Save"}
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
          <Box style={{ marginBottom: "30px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row" justifyContent="space-between">
              <Grid item xs={12} md={8}>
                <Grid spacing={2} container direction="row">
                  <Grid item xs={12} md={6}>
                    <Box style={{ display: isEditMode ? "none" : "block" }}>
                      <CommonAutoCompleteField
                        cssClassName="customTextField"
                        label="Vehicle Number"
                        placeholder="Enter Vehicle Number"
                        name="registrationNumber"
                        optionsType={vehicleRegNumberArr}
                        getOptionLabel={(option) => option.registrationNumber || ""}
                        required
                        value={
                          vehicleRegNumberArr.find(
                            (st: any) => st.registrationNumber === formik.values.registrationNumber
                          ) || null
                        }
                        onChange={(option: any) => {
                          if (
                            option &&
                            option.registrationNumber !== "" &&
                            option.vehicleId !== 0
                          ) {
                            getVehicleStatusByVehicleId(
                              option.vehicleId,
                              option.registrationNumber
                            );
                            handleChange({ target: { value: option.vehicleId } });
                          } else {
                            formik.setFieldValue("registrationNumber", "");
                            handleChange({ target: { value: null } });
                          }
                        }}
                        onKeyUp={(e: any) => {
                          setVehicleNumberLength(e.target.value.length);
                          setVehicleNumber(e.target.value);

                          if (e.target.value.length == 2 && vehicleNumberLength < 2) {
                            getVehicleByRegistrationNo(e.target.value);
                            return;
                          }
                        }}
                        onKeyDownCapture={(e: any) => {
                          if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
                          else handleChange(e);
                        }}
                        onPaste={(e: any) => {
                          if (/[^A-Za-z0-9\d]/.test(e.clipboardData.getData("text"))) {
                            e.preventDefault();
                            return;
                          }

                          if (e.clipboardData.getData("text").length >= 2)
                            getVehicleByRegistrationNo(e.clipboardData.getData("text"));
                        }}
                        error={
                          formik.touched.registrationNumber &&
                          Boolean(formik.errors.registrationNumber)
                        }
                        helperText={
                          formik.touched.registrationNumber && formik.errors.registrationNumber
                        }
                      />
                    </Box>
                    <Box style={{ display: isEditMode ? "block" : "none" }}>
                      <TextField
                        className={"customTextField"}
                        required
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Vehicle Number"
                        name="registrationNumber"
                        id="registrationNumber"
                        placeholder="Enter Vehicle Number"
                        disabled={true}
                        value={formik.values.registrationNumber}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                    <Box>
                      <FormControl component="fieldset">
                        <FormLabel component="legend" className={classes.legend}>
                          Location at Terminal
                        </FormLabel>
                        <RadioGroup
                          row
                          aria-label="terminalLocationId"
                          name="terminalLocationId"
                          value={formik.values.terminalLocationId}
                          onChange={(event: any) => {
                            formik.setFieldValue("terminalLocationId", event.target.value);
                          }}
                        >
                          <FormControlLabel
                            style={{ marginRight: "10px" }}
                            value="Scanner Station (Passthrough)"
                            control={<Radio />}
                            label="Scanner Station (Passthrough)"
                          />
                          <FormControlLabel
                            style={{ marginRight: "10px" }}
                            value="Scanner Station (Gantry)"
                            control={<Radio />}
                            label="Scanner Station (Gantry)"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <CommonAutoCompleteField
                        required
                        cssClassName="customTextField"
                        label="Anomaly Detection"
                        placeholder="Select Anomaly Detection"
                        optionsType={anomalyDetectionArr}
                        getOptionLabel={(option: any) => option.label || ""}
                        onChange={(row: any) => {
                          setValues({ ...values, anomly: row?.value || "" });
                          handleChange({ target: { value: row?.value } });
                          setEnableSecondaryInspection(row?.value === "yes");
                          if (row?.value === "no") formik.setFieldValue("secondaryInspection", "");
                        }}
                        value={
                          anomalyDetectionArr.find(
                            ({ value }: any) => value === formik.values.anomly
                          ) || ""
                        }
                        error={formik.touched.anomly && Boolean(formik.errors.anomly)}
                        helperText={formik.touched.anomly && formik.errors.anomly}
                      />
                    </Box>
                  </Grid>
                  {formik.values.anomly === "yes" && (
                    <Grid item xs={12} md={4} lg={2} style={{ paddingRight: 0 }}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={Boolean(formik.values.deepScan)}
                            onChange={formik.handleChange}
                            name="deepScan"
                            color="primary"
                          />
                        }
                        label="Deep scan"
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} md={6}>
                    <Box style={{ display: enableSecondaryInspection ? "block" : "none" }}>
                      <CommonAutoCompleteField
                        required
                        cssClassName="customTextField"
                        label="Assign Secondary Department"
                        placeholder="Select Secondary Department"
                        optionsType={inspectionDepartmentsArr}
                        getOptionLabel={(option: any) => option.name || ""}
                        onChange={(value: any) => {
                          setValues({ ...values, secondaryInspection: value.name || "" });
                          setSecondaryInspectionTerminalId(value.id);
                          handleChange({ target: { value: value.name } });
                        }}
                        value={
                          inspectionDepartmentsArr.find(
                            (value: any) => value.name === formik.values.secondaryInspection
                          ) || ""
                        }
                        disabled={false}
                        error={
                          formik.touched.secondaryInspection &&
                          Boolean(formik.errors.secondaryInspection)
                        }
                        helperText={
                          formik.touched.secondaryInspection && formik.errors.secondaryInspection
                        }
                      />
                    </Box>
                    <Box style={{ display: enableSecondaryInspection ? "none" : "block" }}>
                      <CommonAutoCompleteField
                        cssClassName="customTextField"
                        label="Assign Secondary Department"
                        placeholder="Select Secondary Department"
                        optionsType={inspectionDepartmentsArr}
                        getOptionLabel={(option: any) => option || ""}
                        disabled={true}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <TextField
                        className="customTextField"
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Reference Number"
                        name="refNum"
                        placeholder="Enter Reference Number"
                        disabled={false}
                        value={formik.values.refNum}
                        onChange={handleChange}
                        error={formik.touched.refNum && Boolean(formik.errors.refNum)}
                        helperText={formik.touched.refNum && formik.errors.refNum}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6} style={{ marginBottom: "-27px" }}>
                    <Box>
                      <TextField
                        size="small"
                        className="customTextField"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onKeyDown={(event: any) => {
                          if (event.key !== "Tab") event.preventDefault();
                        }}
                        label="Possible Issues"
                        disabled={false}
                        error={formik.touched.comment && Boolean(formik.errors.comment)}
                        helperText={formik.touched.comment && formik.errors.comment}
                      />
                      <Box
                        className={classes.multiselectConfigFileCompression}
                        style={{
                          bottom:
                            formik.touched.comment && Boolean(formik.errors.comment)
                              ? "55px"
                              : "35px",
                        }}
                      >
                        <MultiSelect2
                          allValues={commentsArr}
                          selctedItems={selectedComments}
                          displayValue={"comment"}
                          placeholder="Select Possible Issues"
                          onSelect={onMultiSelectSelection}
                          onRemove={onMultiSelectRemove}
                          ref={multiselectRef}
                        />
                      </Box>
                    </Box>
                  </Grid>
                  {/* File Upload */}
                  <Grid item xs={12} md={6}>
                    <Box
                      {...getRootProps()}
                      p={0}
                      pl={1}
                      border={"1px solid rgb(196 196 196)"}
                      borderRadius={5}
                      height={38}
                      pb={4}
                      overflow={"auto"}
                      display={"flex"}
                      flexWrap={"wrap"}
                      borderColor={isDragActive ? "error.main" : "rgb(196 196 196)"}
                      style={{ cursor: "pointer" }}
                    >
                      <input {...getInputProps()} />

                      {fileToUpload.length ? (
                        fileToUpload.map((file, index) => {
                          return (
                            <div
                              key={file.name}
                              style={{
                                marginTop: "6px",
                                backgroundColor: "#E67817",
                                padding: "3px 15px 3px 5px",
                                borderRadius: "10px",
                                maxWidth: "122px",
                                display: "flex",
                                flexWrap: "wrap",
                                marginLeft: "5px",
                              }}
                            >
                              <div
                                style={{
                                  maxWidth: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  fontSize: "11px",
                                  color: "white",
                                }}
                              >
                                {file.name}
                              </div>
                              <IconButton
                                aria-label="Search"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  removeFileFromIndex(index);
                                }}
                                edge="end"
                                className="icon-button-search"
                                style={{
                                  color: "white",
                                  padding: 0,
                                  marginTop: "2px",
                                  width: "10px",
                                  height: "10px",
                                  overflow: "hidden",
                                  marginRight: "2px !important",
                                }}
                              >
                                <Close />
                              </IconButton>
                            </div>
                          );
                        })
                      ) : isDragActive ? (
                        <p>Drop a file here ...</p>
                      ) : (
                        <p style={{ color: "black", marginTop: 9, paddingBottom: 10 }}>
                          {/* Drag and drop file here,or click to select a file */}
                          Upload File(s)
                        </p>
                      )}
                    </Box>
                    <Box>
                      <p style={{ color: "#f44336", marginBottom: 0 }}>
                        <ul
                          style={{
                            paddingLeft: "16px",
                            margin: 0,
                            display: isValidFileType.includes(false) ? "block" : "none",
                          }}
                        >
                          <li>
                            Only{" "}
                            {validFileTypes.map((type: any, index: number) => {
                              return index < validFileTypes.length - 1 ? `${type},` : type;
                            })}{" "}
                            files are allowed.
                          </li>
                        </ul>
                        <ul
                          style={{
                            paddingLeft: "16px",
                            margin: 0,
                            display: isValidFileSize.includes(false) ? "block" : "none",
                          }}
                        >
                          <li>File size cannot exceed {validFileSize}MB.</li>
                        </ul>
                      </p>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <TextField
                        multiline
                        rows={1}
                        rowsMax={8}
                        className="customTextField"
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Remarks"
                        name="remarks"
                        placeholder="Enter Remarks"
                        disabled={false}
                        value={formik.values.remarks}
                        onChange={handleChange}
                        error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                        helperText={formik.touched.remarks && formik.errors.remarks}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Fade in={Boolean(formik.values.registrationNumber)}>
                      <Box>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={openCamera}
                          startIcon={<CameraAltIcon />}
                          style={{
                            backgroundColor: "#E67817",
                            color: "#fff",
                          }}
                        >
                          Capture Image
                        </Button>
                      </Box>
                    </Fade>
                  </Grid>

                  {/* read only field */}
                  {/* <Grid item xs={12} md={4}>
                <Box>
                  <CommonAutoCompleteField
                    cssClassName="customTextField"
                    error={formik.touched.vehicleStatusId && Boolean(formik.errors.vehicleStatusId)}
                    helperText={formik.touched.vehicleStatusId && formik.errors.vehicleStatusId}
                    label="Vehicle Status"
                    placeholder="Vehicle Status"
                    name="vehicleStatusId"
                    optionsType={vehicleStatusArr}
                    getOptionLabel={(option) => option.name}
                    disabled={true}
                    value={
                      vehicleStatusArr.find((st: any) => st.id === formik.values.vehicleStatusId) ||
                      null
                    }
                    onChange={(option: any) => {
                      if (option && option.id !== 0) {
                        formik.setFieldValue("vehicleStatusId", option.id);
                        handleChange({ target: { value: option.id } });
                      } else {
                        handleChange({ target: { value: null } });
                      }
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box>
                  <TextField
                    className="customTextField"
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Vehicle Type"
                    name="vehicleType"
                    placeholder="Vehicle Type"
                    disabled={true}
                    value={formik.values.vehicleType}
                    error={formik.touched.vehicleType && Boolean(formik.errors.vehicleType)}
                    helperText={formik.touched.vehicleType && formik.errors.vehicleType}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box>
                  <TextField
                    className="customTextField"
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Type of Consignment"
                    name="consignmentType"
                    placeholder="Type of Consignment"
                    disabled={true}
                    value={formik.values.consignmentType}
                    error={formik.touched.consignmentType && Boolean(formik.errors.consignmentType)}
                    helperText={formik.touched.consignmentType && formik.errors.consignmentType}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box>
                  <TextField
                    className="customTextField"
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Type of Cargo"
                    name="cargoType"
                    placeholder="Type of Cargo"
                    disabled={true}
                    value={formik.values.cargoType}
                    error={formik.touched.cargoType && Boolean(formik.errors.cargoType)}
                    helperText={formik.touched.cargoType && formik.errors.cargoType}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box>
                  <TextField
                    className="customTextField"
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Vehicle Entry Date/Time"
                    name="entryDateTime"
                    placeholder="Vehicle Entry Date/Time"
                    disabled={true}
                    value={
                      formik.values.entryDateTime
                        ? moment(formik.values.entryDateTime).format("DD-MM-YYYY hh:mm a")
                        : formik.values.entryDateTime
                    }
                    error={formik.touched.entryDateTime && Boolean(formik.errors.entryDateTime)}
                    helperText={formik.touched.entryDateTime && formik.errors.entryDateTime}
                  />
                </Box>
              </Grid> */}
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Paper elevation={1} variant="outlined" style={{ padding: "20px" }}>
                  <Grid spacing={2} container direction="row" justifyContent="space-between">
                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Vehicle Type:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>{formik.values.vehicleType || "-"}</Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Vehicle Status:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>
                        {vehicleStatusArr.find((st: any) => st.id === formik.values.vehicleStatusId)
                          ?.name || "-"}
                      </Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Type of Cargo:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>{formik.values.cargoType || "-"}</Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Consignment:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>{formik.values.consignmentType || "-"}</Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Vehicle Entry Date:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>
                        {formik.values.entryDateTime
                          ? moment(formik.values.entryDateTime).format("DD-MM-YYYY hh:mm a") || "-"
                          : formik.values.entryDateTime || "-"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </>
          <Box style={{ marginTop: "30px", marginBottom: "30px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row">
              <Grid item xs={12} md={3} lg={2}>
                <CommonAutoCompleteField
                  cssClassName="customTextField"
                  error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
                  helperText={formik.touched.filterBy && formik.errors.filterBy}
                  label="Filter by"
                  placeholder="Filter by"
                  disableClearable={true}
                  name="filterBy"
                  optionsType={filteryByArr}
                  getOptionLabel={(option: any) => option.label || ""}
                  onChange={(row: any) => {
                    row ? setValues({ ...values, filterBy: row.value || "" }) : "";
                    if (row === null) {
                      formik.setFieldValue("filterBy", null);
                    }
                    filterByAction(row);
                  }}
                  value={
                    filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                lg={2}
                className={!isCustomDate ? classes.hideDatesGrid : ""}
              >
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"Start Date"}
                  name={"startDate"}
                  datePickerRef={startDatePickerRef}
                  value={formik.values.startDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                    formik.setFieldValue("endDate", "");
                  }}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                lg={2}
                className={!isCustomDate ? classes.hideDatesGrid : ""}
              >
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"End Date"}
                  name={"endDate"}
                  datePickerRef={endDatePickerRef}
                  value={formik.values.endDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                  }}
                  minDate={formik.values.startDate}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Grid>
              <Grid item xs={12} md={isCustomDate ? 3 : 4} lg={2} style={{ paddingRight: 0 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={Boolean(formik.values.InProgressVehiclesDataOnly)}
                      onChange={formik.handleChange}
                      name="InProgressVehiclesDataOnly"
                      color="primary"
                    />
                  }
                  label="In Progress Vehicles"
                />
              </Grid>
              <Grid item xs={12} md={isCustomDate ? 12 : 5} lg={isCustomDate ? 4 : 8}>
                <Box textAlign="right" mt={1} mb={1} style={{ float: "right" }}>
                  <CommonButton cssClass="customSubmitBtn" onClick={() => resetGrid()}>
                    Reset
                  </CommonButton>
                  <CommonButton cssClass="customSubmitBtn" isGreen onClick={handleSearch}>
                    Search
                  </CommonButton>
                </Box>
              </Grid>
            </Grid>
          </>
          <div className="">
            <CommonMaterialGrid
              rows={vehicleRecord}
              columns={displayColumns}
              loader={loader}
              defaultPerPageRecord={15}
              height={550}
              deletedRow={true}
              isExport={isExport}
              exportHandler={exportHandler}
              filename={`Vehicle_insp_scanner_${Date.now()}`}
            />
          </div>
        </CardContent>
      </Card>
      <TransitionDialog
        isOpen={isOpenDeleteDailog}
        handleClose={handleCloseDeleteDialog}
        heading={"Confirmation"}
        handleConfirm={handleDeleteDialog}
      >
        Are you sure you want to delete this record?
        <Box style={{ marginTop: "10px", marginBottom: "10px" }}>
          <TextField
            required
            multiline
            rows={1}
            rowsMax={5}
            size="small"
            fullWidth
            className="customTextField"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            label="Remarks"
            name="remarks"
            id="remarks"
            placeholder="Enter Remarks"
            disabled={false}
            value={deleteRemarks}
            onChange={(e) => {
              const { value } = e.target;
              setDeleteRemarks(value);
            }}
            error={isDeleteMode && !deleteRemarks}
            helperText={isDeleteMode && !deleteRemarks && "This field is required"}
          />
        </Box>
      </TransitionDialog>

      <TransitionDialog
        isOpen={isOpenSaveDailog}
        handleClose={handleCloseSaveDialog}
        heading={"Confirmation"}
        handleConfirm={handleSaveDialog}
      >
        Record against vehicle already present in same trip, do you want to save another one?.
      </TransitionDialog>

      {/* Camera Capture Dialog */}
      <Dialog
        open={cameraOpen}
        onClose={closeCamera}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: "#000",
          },
        }}
      >
        <DialogTitle style={{ color: "#fff", display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h6">Capture Image</Typography>
          <IconButton onClick={closeCamera} style={{ color: "#fff" }}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
              backgroundColor: "#000",
            }}
          >
            {imageDataURL ? (
              <img
                src={imageDataURL}
                alt="captured"
                style={{ maxWidth: "100%", maxHeight: "500px" }}
              />
            ) : (
              <video
                ref={playerRef}
                autoPlay
                playsInline
                style={{
                  maxWidth: "100%",
                  maxHeight: "500px",
                  backgroundColor: "#000",
                }}
              >
                <track kind="captions" />
              </video>
            )}
          </Box>
        </DialogContent>
        <DialogActions style={{ backgroundColor: "#000", padding: "16px" }}>
          {!imageDataURL && (
            <>
              <Button
                onClick={closeCamera}
                style={{ color: "#fff", marginRight: "8px" }}
                variant="outlined"
              >
                Cancel
              </Button>
              <Button
                onClick={captureImage}
                style={{ backgroundColor: "#E67817", color: "#fff" }}
                variant="contained"
              >
                Capture
              </Button>
            </>
          )}
          {imageDataURL && (
            <>
              <Button
                onClick={() => {
                  setImageDataURL(null);
                  openCamera();
                }}
                style={{ color: "#fff", marginRight: "8px" }}
                variant="outlined"
              >
                Retake
              </Button>
              <Button
                onClick={confirmAndAddImage}
                style={{ backgroundColor: "#E67817", color: "#fff" }}
                variant="contained"
              >
                Add Image
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
